<template>
    <SoliResponsiveDialog
        ref="dialog"
        title="Update Time Clock"
        :subtitle="
            !!$page.props.currentTimeClock
                ? `Clocked-in on ${globalMomentFullDateAtTime(
                      $page.props.currentTimeClock.starts_at
                  )}`
                : `${currentTime}`
        "
        :size="400"
        @reset="$emit('reset')"
        :mobile-scroll="false"
        persistent
    >
        <template #body>
            <v-container v-if="showOptions" class="pt-0">
                <v-form ref="form">
                    <v-select
                        v-model="selectRate"
                        :items="rateOptions"
                        item-text="role.name"
                        item-value="id"
                        return-object
                        dense
                        class="soli-round"
                        outlined
                        color="primary"
                        label="Working As"
                        hide-details="auto"
                        :rules="[(v) => !!v || 'Rate is required']"
                        :loading="ratesLoading"
                    >
                        <template v-slot:item="data">
                            <v-list-item-content>
                                <v-list-item-title
                                    v-html="data.item.role.name"
                                ></v-list-item-title>
                                <v-list-item-subtitle>
                                    {{
                                        `$${data.item.amount}/hour`
                                    }}</v-list-item-subtitle
                                >
                            </v-list-item-content>
                        </template>
                    </v-select>
                    <v-switch
                        v-if="rateOptions?.length > 1"
                        v-model="preference"
                        label="Remember preference"
                        color="primary"
                    />
                </v-form>
            </v-container>
            <v-divider />
            <v-card-actions class="pb-0">
                <v-spacer />
                <v-btn text rounded class="soli-grey" @click="reset()"
                    >Nevermind</v-btn
                >
                <v-btn
                    color="accent"
                    text
                    rounded
                    :loading="loading"
                    :disabled="ratesLoading"
                    @click="toggleTimeClock()"
                    >{{
                        !!$page.props.currentTimeClock
                            ? "Clock-out"
                            : "Clock-in"
                    }}</v-btn
                >
            </v-card-actions>
        </template>
    </SoliResponsiveDialog>
</template>

<script>
import axios from "axios";
import GlobalMoment from "../Mixins/GlobalMoment";
import Skeleton from "./Skeleton.vue";

export default {
    props: {
        user: {
            type: Object,
            required: true,
        },
    },
    components: {
        Skeleton,
    },
    mixins: [GlobalMoment],
    data() {
        return {
            showForm: false,
            currentTime: this.globalMomentFullDateAtTimeSeconds(new Date()),
            selectRate: null,
            preference: null,
            rateOptions: null,
            loading: false,
            ratesLoading: true,
        };
    },
    computed: {
        showOptions() {
            return !this.$page.props.currentTimeClock;
        },
    },
    methods: {
        checkDefaultRate() {
            const defaultRate = this.rateOptions.find(
                (rate) => localStorage.getItem("defaultRate") == rate.id
            );
            if (defaultRate) {
                this.selectRate = defaultRate;
                this.preference = true;
            }
        },
        reset() {
            this.$refs.dialog.show = false;
        },
        getRates() {
            axios
                .get(`/api/users/pay-rates/${this.user.id}`, {
                    params: {
                        timeClockRates: 1,
                    },
                })
                .then((resp) => {
                    this.rateOptions = resp.data;
                    this.ratesLoading = false;
                    if (this.rateOptions.length == 1) {
                        this.selectRate = this.rateOptions[0];
                    }
                    this.checkDefaultRate();
                });
        },
        setCurrentTime() {
            setInterval(() => {
                this.currentTime = this.globalMomentFullDateAtTimeSeconds(
                    new Date()
                );
            }, 1000);
        },
        toggleTimeClock() {
            this.loading = true;
            const currentTimeClock = this.$page.props.currentTimeClock;

            if (this.preference) {
                localStorage.setItem("defaultRate", this.selectRate.id);
            } else {
                localStorage.removeItem("defaultRate");
            }

            const options = {
                preserveState: true,
                preserveScroll: true,
                onSuccess: () => {
                    this.$emit("success");
                    this.reset();
                    this.loading = false;
                },
                onError: (errors) => {
                    console.log(errors);
                    this.loading = false;
                },
            };

            if (currentTimeClock) {
                this.$inertia.put(
                    `/time-clocks/${currentTimeClock.id}`,
                    {
                        id: currentTimeClock.id,
                        realTime: 1,
                    },
                    options
                );
            } else {
                if (!this.$refs.form.validate()) return;
                this.$inertia.post(
                    `/time-clocks`,
                    {
                        user_id: this.$page.props.auth.user.id,
                        role_id: this.selectRate.role_id,
                        realTime: 1,
                    },
                    options
                );
            }
        },
    },
    mounted() {
        this.setCurrentTime();
        this.getRates();
    },
};
</script>
